// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page_faq[data-v-ab207328]{margin:60px 0 40px}.page_faq-title[data-v-ab207328]{margin-bottom:24px;font-style:normal;font-weight:900;font-size:28px;line-height:38px;text-align:center}.page_faq .list-item[data-v-ab207328]{padding:20px 0}.page_faq-answer[data-v-ab207328]{padding:20px 0;font-style:normal;font-weight:400;font-size:16px;line-height:22px}@media(max-width:960px){.page_faq-answer[data-v-ab207328]{text-align:center}}", ""]);
// Exports
module.exports = exports;
